
import { Vue, Component, Ref } from 'vue-property-decorator'
import flvjs from 'flv.js'

@Component({
  name: 'VideoModal',
  components: {},
})
export default class VideoModal extends Vue {
  @Ref('videoPlayer')
  private refVideoPlayer

  private visible = false

  private mounted() {
    Vue.prototype.$privewVideo = this.preview
  }

  public preview({ type, url }: { type: 'mp4' | 'flv'; url: string }) {
    this.visible = true
    this.$nextTick(() => {
      if (flvjs.isSupported()) {
        let player = flvjs.createPlayer({ type, url })
        player.attachMediaElement(this.refVideoPlayer)
        player.load()
      }
    })
  }
}
